import * as XLSX from 'xlsx';
class SpeciesItem {
    constructor(apiService = null) {
        this.obj_name = 'speciesItem';
        this.apiService = apiService; // 將 ApiService 實例儲存為屬性
    }

    // 共用的 API 呼叫方法
    async callApi(method, endpoint, parameter = {}, progressEvent = null) {
        const apiConfig = {
            url: `${this.apiService.url}${this.obj_name}/${endpoint}`,
            parameter,
        };

        return new Promise((resolve) => {
            if (method === 'get') {
                apiConfig.url += `?${this.apiService.getMethodEncryp(parameter)}`;
                this.apiService.getApi({
                    url: apiConfig.url,
                    success: resolve,
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            } else if (method === 'post') {
                this.apiService.postFormDataApi({
                    url: apiConfig.url,
                    parameter: apiConfig.parameter,
                    success: resolve,
                    progress: (res) => {
                        this.apiService.debug(res);
                        if (progressEvent) {
                            progressEvent(res);
                        }
                    },
                    error: (res) => {
                        this.apiService.debug('error:', res);
                        resolve(res);
                    },
                });
            }
        });
    }

    // API 方法
    // 物種劑量 | 101 更新物種劑量
    async addOrUpdItemsSpeciesCategorySetting(parameter, progressEvent = null) {
        return this.callApi('post', 'addOrUpdItemsSpeciesCategorySetting', parameter, progressEvent);
    }

    // 物種劑量 | 102 取得物種劑量列表
    async getItemsSpeciesCategorySetting(parameter = null) {
        return this.callApi('get', 'getItemsSpeciesCategorySetting', parameter);
    }

    //getDataAndWithHeaders
    getDataAndWithHeaders(dosageList){
        //# = species_category_id
        //物種代碼 = code
        //物種名稱 = name
        let headers = [
            '#','物種代碼','物種名稱'
        ];
        for (let index = 0; index < dosageList.length; index++) {
            const dosage = dosageList[index];
            headers.push(
                `(${dosage.item_id})${dosage.ERP_no}-${dosage.item_name}`
            )
        }
        return headers
    }
    getDataAndWithBody(speciesList,headers){
        let bodyData = []

        for (let i = 0; i < speciesList.length; i++) {
            const species = speciesList[i];
            //找出索引位置
            let speciesItem = [
                species.species_category_id,
                species.code,
                species.name
            ]
            //先宣告藥劑空欄位，確保資料不會跑偏位
            for (let n = speciesItem.length; n < headers.length; n++) {
                speciesItem.push(0)
            }

            for (let n = 0; n < species.dosages.length; n++) {
                const dosage = species.dosages[n];
                const headerItemIndex = headers.findIndex(item=>item===`(${dosage.item_id})${dosage.ERP_no}-${dosage.item_name}`)
                if ( headerItemIndex != -1 ){
                    speciesItem[headerItemIndex] = dosage.dosage == -1 ? 0 : dosage.dosage
                }
            }
            bodyData.push(speciesItem)
        }

        return bodyData
    }
    //匯出物種劑量參數
    async exportDoseParameters(speciesList,dosageList){

        const dataWithHeaders = this.getDataAndWithHeaders(dosageList);

        const dataWithBody = this.getDataAndWithBody(speciesList,dataWithHeaders)

        // // 生成工作表和工作簿
        const worksheet = XLSX.utils.aoa_to_sheet([dataWithHeaders,...dataWithBody]); // aoa 表示數組數組結構
        // // 設定自動寬度
        const colWidths = [dataWithHeaders,...dataWithBody][0].map((_, colIndex) =>
            Math.max(
                ...[...dataWithHeaders, ...dataWithBody].map(row => 
                    (row[colIndex] ? row[colIndex].toString().length : 0)
                )
            )
        );
        worksheet['!cols'] = colWidths.map(width => ({ wch: width + 6 })); // wch: 寬度，+2 是增加緩衝
        // 設定凍結標題列和病歷編號欄
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        // 下載檔案
        XLSX.writeFile(workbook, `物種劑量參數表.xlsx`);

    }

    async readExcelDataToJsonData(fileData){
        const data = new Uint8Array(fileData);
        const workbook = XLSX.read(data, { type: 'array' });
        // 取得第一個工作表名稱
        const firstSheetName = workbook.SheetNames[0];
        // 取得第一個工作表內容
        const worksheet = workbook.Sheets[firstSheetName];
        // 將工作表內容轉換為陣列格式
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); // header: 1 表示使用陣列格式
        console.log('Excel 資料轉為陣列:', jsonData);
        return jsonData
    }
}

export default SpeciesItem;
